import { fetchSlimProfiles } from "@/api/hooks/profile";
import { useAppSession } from "@/auth/AppSessionContext";
import { Dashboards } from "@/dashboard";
import { setTitle } from "@/effects";
import { useAppDispatch } from "@/reducer";
import { t } from "@lingui/core/macro";
import { useEffect } from "react";

export default function ProfilePage() {
  const dispatch = useAppDispatch();
  const { sessionActivated } = useAppSession();

  useEffect(() => {
    setTitle(t({ id: "profiles.title", message: "Profiles" }));
  }, []);

  useEffect(() => {
    if (!sessionActivated) {
      return;
    }

    dispatch(fetchSlimProfiles());
  }, [sessionActivated, dispatch]);

  return sessionActivated ? <Dashboards maximized={true} allowCollapse={false} isSideNav={false} /> : null;
}
